import { useUserProfileApi } from '@/api/users';
import { Toaster } from '@/components/ui/sonner';
import { SidebarProvider, useSidebar } from '@/hooks/useSidebarContext';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';

function AdminLayoutContent() {
  const { isCollapsed, toggleSidebar } = useSidebar();
  const { data: user, isLoading } = useUserProfileApi();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && user?.type !== 'ditto') {
      navigate('/', { replace: true });
    }
  }, [isLoading, user?.type, navigate]);

  if (isLoading || user?.type !== 'ditto') {
    return null;
  }

  return (
    <div className="flex h-screen bg-background">
      <AdminSidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <main className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
        <Toaster />
      </main>
    </div>
  );
}

export function AdminLayout() {
  return (
    <SidebarProvider>
      <AdminLayoutContent />
    </SidebarProvider>
  );
}
